<ng-container *ngIf="isMobile; else tabletAndDesktop">
  <section class="usp-card">
    <img [appLazyLoadImage]="cdnUrl + card.mobileImage" alt=""/>
    <h5 [lang]="market">{{ card.headline | translate }}</h5>
  </section>
</ng-container>

<ng-template #tabletAndDesktop>
  <section class="usp-card">
    <img [appLazyLoadImage]="cdnUrl + card.image" alt=""/>
    <div class="usp-card__head-and-subline">
      <h3 [lang]="market">{{ card.headline | translate }}</h3>
      <p [lang]="market">{{ card.subline | translate }}</p>
    </div>
  </section>
</ng-template>
